import * as stylex from "@stylexjs/stylex";
import { useId } from "react";
import { copy } from "@/copy";
import type { Breakpoint } from "@/domain/breakpoint";
import "@/theme/tokens.stylex";
import { colors, radii } from "@/theme/tokens.stylex";
import { Eyebrow } from "@/ui/Eyebrow";
import { PlanRow, type PreviewPlan, type PreviewTile, WeatherTile } from "./DayPreview";
type EventFactsProps = {
  breakpoint: Breakpoint;
  day: string;
  scope: "time" | "day";
  weather?: PreviewTile | "none";
  plans: readonly PreviewPlan[];
};
const words = copy.events.preview;
const styles = {
  card: {
    kzQI83: "x1iyjqo2",
    kmuXW: "x2lah0s",
    kB7OPa: "x9f619",
    k1xSpc: "xrvj5dj",
    kGNEyG: "x7a106z",
    kfiyM8: "x10ukxgv",
    kaIpWk: "xwe7p7i",
    kWkggS: "xh540kj",
    kMwMTN: "x1a11ngh",
    $$css: true
  }
};
const sizes = {
  large: {
    kumcoG: "xm3j75z",
    kOIVth: "xdim9vw",
    kLKAdn: "x7sb2j6",
    kg3NbH: "x1sdxjpb",
    kGO01o: "xq1608w",
    $$css: true
  },
  normal: {
    kumcoG: "x1uz3ohg",
    kOIVth: "x1y9zxd1",
    kLKAdn: "x1p5oq8j",
    kg3NbH: "xj7an9n",
    kGO01o: "x1gan7if",
    $$css: true
  },
  small: {
    kumcoG: "x1mkdm3x",
    kOIVth: "x33pbmt",
    kmVPX3: "x1qhigcl",
    $$css: true
  }
};
export function EventFacts({
  breakpoint,
  day,
  scope,
  weather,
  plans
}: EventFactsProps) {
  const heading = useId();
  const byDay = scope === "day";
  return <section aria-label={words.facts} {...stylex.props(styles.card, sizes[breakpoint])}>
      <div className="x78zum5 xdt5ytf xou54vl xeuugli">
        <Eyebrow>{words.forecast(day)}</Eyebrow>
        {weather === "none" && <p className="x1ghz6dp xosj86m x15i68ds xfrs9s4">{words.noForecast}</p>}
        {weather && weather !== "none" && <WeatherTile {...weather} />}
      </div>
      <div className="x78zum5 xdt5ytf x1c1vhfx xeuugli">
        <Eyebrow>
          <span id={heading}>{byDay ? words.alsoDay(plans.length) : words.also(plans.length)}</span>
        </Eyebrow>
        {plans.length === 0 ? <p className="x1ghz6dp xosj86m x15i68ds xfrs9s4">{byDay ? words.nothingDay : words.nothing}</p> : <ul aria-labelledby={heading} className="xe8uvvx x1ghz6dp x1717udv x78zum5 xdt5ytf x1665zp3">
            {plans.map(plan => <PlanRow key={plan.id} {...plan} />)}
          </ul>}
      </div>
    </section>;
}